@if (configuration()) {
  <celum-icon class="message_icon" [configuration]="configuration().icon"></celum-icon>
  <p class="message_title" [style.color]="configuration().color">
    {{ configuration().title | language: null : true : configuration().titleParams }}
  </p>
  @if (!configuration().messages || configuration().messages.length === 0) {
    <ng-content></ng-content>
  }

  @for (message of configuration().messages; track $index) {
    <span [innerHTML]="message | language: null : true : configuration().messageParams | sanitized"></span>
  }
}
